import React, { useEffect } from "react";

import { DatePicker, Form, Input } from "antd";
import moment from "moment";

import LdasModal from "../LdasModal";

const LdasValidityAddModal = ({ visible, editingCert, onCancel, onSave }) => {
  const [form] = Form.useForm();
  const isEdit = Boolean(editingCert);

  useEffect(() => {
    if (!visible) return;
    if (editingCert) {
      form.setFieldsValue({
        certBody: editingCert.certBody ?? "",
        certDate: editingCert.certDate
          ? moment(editingCert.certDate, "YYYY-MM-DD")
          : undefined,
      });
      return;
    }
    form.resetFields();
  }, [visible, editingCert, form]);

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const handleSubmit = async () => {
    try {
      const { certBody, certDate } = await form.validateFields();
      await Promise.resolve(
        onSave({
          ...(isEdit && editingCert?.id !== undefined && editingCert.id !== null
            ? { id: editingCert.id }
            : {}),
          certBody: certBody.trim(),
          certDate: certDate ? certDate.format("YYYY-MM-DD") : null,
        }),
      );
      form.resetFields();
    } catch {
      /* validate 실패 또는 onSave 거부 */
    }
  };

  return (
    <LdasModal
      title={isEdit ? "인증 수정" : "인증 추가"}
      visible={visible}
      onCancel={handleCancel}
      onOk={handleSubmit}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="certBody"
          label="인증기관"
          required
          rules={[
            { required: true, message: "인증기관을 입력해 주세요" },
            {
              validator: (_, value) => {
                if (value && !String(value).trim()) {
                  return Promise.reject(new Error("인증기관을 입력해 주세요"));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder="예: USP, NSF, IFOS" autoComplete="off" />
        </Form.Item>
        <Form.Item
          name="certDate"
          label="인증 취득일"
          style={{ marginBottom: 0 }}
          required
          rules={[{ required: true, message: "인증 취득일을 선택해 주세요" }]}
        >
          <DatePicker
            style={{ width: "100%" }}
            placeholder="날짜 선택"
            format="YYYY-MM-DD"
          />
        </Form.Item>
      </Form>
    </LdasModal>
  );
};

export default LdasValidityAddModal;
